import React, { Component } from 'react';
import PropTypes from 'prop-types';

import OPTIONS from '../Options.js';

import { withClinicalData } from '../contexts/clinicalData';

import QALayout from '../layout/QA';
import CropImage from '../components/CropImage.js';

import Camera from 'images/ask/icons/camera.svg';

class SnapPhoto extends Component {
  constructor(props) {
    super(props);

    if (OPTIONS.snapPhoto.clearBodyLocationsOnLoad) {
      props.clinicalData.clearBodyLocation();
    }
  }

  render() {
    return (
      <QALayout
        className="snap-photo"
        completionPercentage={20}
        sidebar={
          <React.Fragment>
            <img className="header-icon" src={Camera} />
            <h2>Snap a photo</h2>
            <p>
              Adjust the square so the skin problem is centered and make sure the photo isn’t blurry.
              The clearer the photo, the more accurately we can analyze it.
            </p>
          </React.Fragment>
        }
        content={
          <CropImage />
        }
      />
    );
  }
}

SnapPhoto.defaultProps = {};

SnapPhoto.propTypes = {
  clinicalData: PropTypes.object.isRequired,
};

export { SnapPhoto };
export default withClinicalData(SnapPhoto);
